import { useDispatch, useSelector } from 'react-redux';
import {
    scanSliceAPI,
    setEmail,
    setMode,
    setSelectedPassIndex,
    updatePassInCustomerData,
} from '../store/scanSlice';
import { useCallback } from 'react';
import { createLogger } from '../../../shared/config/logger';
import { extractErrorMessage } from '../../../shared/utils/errorHandling';
import { normalizeEmail } from '../../../shared/utils/stringUtils';
const logger = createLogger('useScan.js');

export const useScan = () => {
    const dispatch = useDispatch();
    const {
        loading,
        rewardsLoading,
        error,
        mode,
        message,
        email,
        customerData,
        passId,
        availableRewards,
        pointRatio,
        shouldFocusInput,
        selectedPassIndex,
        customerLookupGeneration,
    } = useSelector((state) => state.scan);

    const handleModeChange = (mode) => {
        logger.info('Handle mode change: ', mode);
        dispatch(setMode(mode));
    };
    const handleEmailChange = (email) => {
        logger.info('Email input change in useScan');
        dispatch(setEmail(email));
    };

    const handleSelectedPassIndexChange = (index) => {
        logger.info('Selected pass index change: ', index);
        dispatch(setSelectedPassIndex(index));
    };

    const updatePassInRedux = (updatedPass) => {
        logger.info('Updating pass in redux', { updatedPass });
        dispatch(updatePassInCustomerData(updatedPass));
    };

    const handleEmailSearch = useCallback(
        async (lookupInput) => {
            logger.info('Customer lookup process started in useScan hook', { lookupInput });
            try {
                const trimmedLookup = (lookupInput || '').trim();
                const normalizedLookup = trimmedLookup.includes('@')
                    ? normalizeEmail(trimmedLookup)
                    : trimmedLookup;
                await dispatch(scanSliceAPI.emailSearch(normalizedLookup)).unwrap();
                logger.info('Customer lookup dispatch completed successfully in useScan hook');

                //await dispatch(setCu)
            } catch (error) {
                const message = extractErrorMessage(error);
                logger.error('Customer lookup failed in useScan hook', { error: message });
                throw new Error(message);
            }
        },
        [dispatch]
    );

    const handleQRSearch = useCallback(
        async (passId) => {
            logger.info('QR search process started in useScan hook', { passId });
            try {
                await dispatch(scanSliceAPI.qrSearch(passId)).unwrap();
                logger.info('QR search dispatch completed successfully in useScan hook');

                //await dispatch(setCu)
            } catch (error) {
                const message = extractErrorMessage(error);
                logger.error('QR search failed in useScan hook', { error: message });
                throw new Error(message);
            }
        },
        [dispatch]
    );

    const handleGetAvailableRewards = useCallback(
        async (passId) => {
            logger.info('Getting available Rewards');
            try {
                await dispatch(scanSliceAPI.getAvailableRewards(passId));
            } catch (error) {
                const message = extractErrorMessage(error);
                logger.error('Email search failed in useScan hook', { error: message });
                throw new Error(message);
            }
        },
        [dispatch]
    );

    return {
        state: {
            error,
            loading,
            rewardsLoading,
            mode,
            message,
            email,
            customerData,
            passId,
            availableRewards,
            pointRatio,
            shouldFocusInput,
            selectedPassIndex,
            customerLookupGeneration,
        },
        //actions
        emailSearch: handleEmailSearch,
        emailChange: handleEmailChange,
        qrSearch: handleQRSearch,
        getRewards: handleGetAvailableRewards,
        setMode: handleModeChange,
        setSelectedPassIndex: handleSelectedPassIndexChange,
        updateCustomerPointsThunk: scanSliceAPI.updateCustomerPointsThunk,
        updatePassInRedux,
    };
};
